import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["input"];
  }

  connect() {
    this.inputWidth = this.dynamicInputWidth;
  }

  set inputWidth(width) {
    this.inputTarget.style.width = `${width}px`;
  }

  get dynamicInputWidth() {
    const style = window.getComputedStyle(this.inputTarget);

    const paddingLeft = parseFloat(style.paddingLeft) || 0;
    const paddingRight = parseFloat(style.paddingRight) || 0;

    return this.measureTextWidth(this.inputTarget.getAttribute("placeholder"), style.font) + paddingLeft + paddingRight;
  }

  measureTextWidth(text, font) {
    const canvas = this.canvas || (this.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");

    context.font = font;

    return context.measureText(text).width;
  }
}
